module.exports = __webpack_public_path__ + "img/worker.dcd2ac39.jpg";